import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Rnd } from 'react-rnd';
import { theme } from '../../../styles/themes/mainTheme';
import IEslTemplateItem, { IEslTemplateItemDimensions, IEslTemplateItemPosition } from '../../../models/esl/eslTemplateElement';
import { EEslTemplateElementType } from '../../../models/enums/eslTemplateType';
import RenderedElement from './RenderedElement';

interface ICanvasElementProps {
  templateItem: IEslTemplateItem;
  onDragAndResize: (id: number, position: IEslTemplateItemPosition, size: IEslTemplateItemDimensions) => void;
  selectedElementId: number;
  setSelectedElementId: Dispatch<SetStateAction<number>>;
}

const CanvasElement = ({ templateItem, onDragAndResize, selectedElementId, setSelectedElementId }: ICanvasElementProps) => {
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    if (selectedElementId && selectedElementId === templateItem.id) return setIsSelected(true);

    setIsSelected(false);
  }, [selectedElementId, templateItem.id]);

  const isResizingEnabled = (element: IEslTemplateItem) => {
    if (element.type === EEslTemplateElementType.Text) return false;
    if (element.type === EEslTemplateElementType.Line)
      return { top: false, topLeft: false, topRight: false, bottom: false, bottomLeft: false, bottomRight: false }

    return true;
  }

  return (
    <Rnd
      size={{ width: templateItem.dimensions.width, height: templateItem.dimensions.height }}
      position={{ x: templateItem.position.left, y: templateItem.position.top }}
      onDragStop={(_event, data) => {
        onDragAndResize(templateItem.id, { left: data.x, top: data.y }, { width: templateItem.dimensions.width, height: templateItem.dimensions.height });
      }}
      onResizeStop={(_event, _direction, ref, _delta, position) => {
        onDragAndResize(templateItem.id, { left: position.x, top: position.y }, { width: ref.offsetWidth, height: ref.offsetHeight });
      }}
      bounds="parent"
      style={{ outline: isSelected ? `2px dashed ${theme.palette.primary.main}` : 'none', outlineOffset: 1, zIndex: isSelected ? 1000 : 1 }}
      onClick={() => setSelectedElementId(templateItem.id)}
      onDrag={(_event, data) => {
        setSelectedElementId(templateItem.id);
        onDragAndResize(templateItem.id, { left: data.x, top: data.y }, { width: templateItem.dimensions.width, height: templateItem.dimensions.height });
      }}
      onResize={(_event, _direction, ref, _delta, position) => {
        setSelectedElementId(templateItem.id);
        onDragAndResize(templateItem.id, { left: position.x, top: position.y }, { width: ref.offsetWidth, height: ref.offsetHeight });
      }}
      lockAspectRatio={templateItem.type === EEslTemplateElementType.Circle || templateItem.type === EEslTemplateElementType.ServiceRequestQRCode || templateItem.type === EEslTemplateElementType.LastCleaningDatetime}
      enableResizing={isResizingEnabled(templateItem)}
      maxHeight={templateItem.type === EEslTemplateElementType.Line ? 5 : undefined}
    >
      <RenderedElement
        element={templateItem}
        onResize={(width, height) => onDragAndResize(templateItem.id, { left: templateItem.position.left, top: templateItem.position.top }, { width, height })}
      />
    </Rnd >
  );
};

export default CanvasElement;